import { z } from 'zod';

import { rpeAnswerSchema } from './rpe-answer';

export type RpeCheckInPayload = z.output<typeof rpeCheckInPayloadSchema>;
export type RpeCheckInPayloadDTO = z.input<typeof rpeCheckInPayloadSchema>;

export const rpeCheckInPayloadSchema = z.object({
  playerId: z.uuid(),
  answers: z.array(rpeAnswerSchema),
});
